const NoPermission = () => {
    return (
        <div className="container bg-white rounded vh-100">
            <div className="row">
            <div className="col-md-12 text-center">
            <p className="text-danger">Sorry you don't have permission to access this page.</p>
            </div>
            </div>
        </div>
    )
};
export default NoPermission;